export default __webpack_public_path__ + "static/media/Speaker_Example.c512dee9.png";